import { connect } from 'react-redux';
import {
  getPatientUpdateLoadingStatus,
  getSidebarPatientsInfoList,
} from 'store/selectors/patientsData';
import { isResearcher } from 'store/selectors/user';
import { getPatientPageUrlId } from 'store/selectors/router';
import { patientUpdate } from 'store/actionCreators/patientsData';
import SidebarPatientInfo from 'components/SidebarPatientInfo';

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => ({
  patientId: getPatientPageUrlId(state),
  updateLoading: getPatientUpdateLoadingStatus(id)(state),
  isResearcher: isResearcher(state),
  data: getSidebarPatientsInfoList(id)(state),
});

const mapDispatchToProps = {
  patientUpdate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SidebarPatientInfo);
